import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import styles from './SecondaryList.css';
import SecondaryItem from './SecondaryItem';

const SecondaryList = ({ activeItem, sections }) => {
  // Iterate over sections and add styles.separator for visually grouping
  return sections.map((section, index) => (
    <ul className={classNames(styles.main, styles.separator)} key={index}>
      {section.map(navItem => (
        <SecondaryItem
          meta={navItem}
          key={navItem.key}
          isActive={navItem.key === activeItem}
        />
      ))}
    </ul>
  ));
};

SecondaryList.displaName = 'SecondaryList';

SecondaryList.propTypes = {
  activeItem: PropTypes.string,
  sections: PropTypes.arrayOf(PropTypes.array).isRequired,
};

export default SecondaryList;
